<template>
  <div>
    <div class="filter-bar">
      <span> 年份 {{ year }} </span>
      <span>
        {{ querytype }}
        <i class="caret"></i>
        <select
          class="filter-item__select"
          v-model="querytype"
          @change="searchCashflowMonth"
        >
          <option :value="'全部'">全部</option>
          <option :value="'客户'">客户</option>
        </select>
      </span>
    </div>
    <div class="canvas-title">{{ title }}-预测图</div>
    <div class="canvas-box">
      <canvas id="myChart" class="myChart"></canvas>
    </div>

    <div class="list-box">
      <div class="list-left">
        <div class="list-cell">
          <div class="list-cell__main height-36">
            <div class="list-cell__index"></div>
            <div class="list-cell__toggle text-header">物料编号/物料名称</div>
          </div>
        </div>
        <div class="list-cell" v-for="(item, index) in list" :key="index">
          <div
            class="list-cell__main"
            :class="selected == index + 1 ? 'bg-color' : ''"
            @click="open(item.monthitems, item.pr_detail, index + 1)"
          >
            <div class="list-cell__index">
              <span>{{ index + 1 }}</span>
            </div>
            <div class="list-cell__content">
              {{ item.pr_code }}/{{ item.pr_detail }}
            </div>
          </div>
        </div>
      </div>
      <div class="list-right">
        <div
          class="list-cell"
          :class="querytype == '客户' ? 'width-customer' : 'width-all'"
        >
          <div class="list-cell__main">
            <div class="list-cell__150 text-header" v-if="querytype == '客户'">
              客户名称
            </div>
            <div
              class="list-cell__toggle text-header"
              v-if="querytype == '客户'"
            >
              客户编号
            </div>
            <div class="list-cell__toggle text-header">型号</div>
            <div class="list-cell__toggle text-header">规格</div>
            <div class="list-cell__toggle text-header">出货累计</div>
            <div class="list-cell__toggle text-header">厂家/品牌</div>
            <div class="list-cell__toggle text-header">单位</div>
            <div class="list-cell__toggle text-header">库存数</div>
            <div class="list-cell__toggle text-header">在途数量</div>
            <div class="list-cell__toggle text-header">最小包装数</div>
            <div class="text-two-header">
              <div :class="querytype != '客户' ? 'width-400' : 'width-200'">
                {{ textArr[8] }}
              </div>
              <div :class="querytype != '客户' ? 'width-400' : 'width-200'">
                <span class="small-header">销售订单</span>
                <span class="small-header">销售预测</span>
                <span class="small-header" v-if="querytype != '客户'"
                  >MRP净需求</span
                >
                <span class="small-header" v-if="querytype != '客户'"
                  >采购需求预测</span
                >
              </div>
            </div>
            <div class="text-two-header">
              <div :class="querytype != '客户' ? 'width-400' : 'width-200'">
                {{ textArr[9] }}
              </div>
              <div :class="querytype != '客户' ? 'width-400' : 'width-200'">
                <span class="small-header">销售订单</span>
                <span class="small-header">销售预测</span>
                <span class="small-header" v-if="querytype != '客户'"
                  >MRP净需求</span
                >
                <span class="small-header" v-if="querytype != '客户'"
                  >采购需求预测</span
                >
              </div>
            </div>
            <div class="text-two-header">
              <div :class="querytype != '客户' ? 'width-400' : 'width-200'">
                {{ textArr[10] }}
              </div>
              <div :class="querytype != '客户' ? 'width-400' : 'width-200'">
                <span class="small-header">销售订单</span>
                <span class="small-header">销售预测</span>
                <span class="small-header" v-if="querytype != '客户'"
                  >MRP净需求</span
                >
                <span class="small-header" v-if="querytype != '客户'"
                  >采购需求预测</span
                >
              </div>
            </div>
            <div class="text-two-header">
              <div :class="querytype != '客户' ? 'width-400' : 'width-200'">
                {{ textArr[11] }}
              </div>
              <div :class="querytype != '客户' ? 'width-400' : 'width-200'">
                <span class="small-header">销售订单</span>
                <span class="small-header">销售预测</span>
                <span class="small-header" v-if="querytype != '客户'"
                  >MRP净需求</span
                >
                <span class="small-header" v-if="querytype != '客户'"
                  >采购需求预测</span
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="list-cell"
          :class="querytype == '客户' ? 'width-customer' : 'width-all'"
          v-for="(items, index2) in list"
          :key="index2"
        >
          <div
            class="list-cell__main"
            :class="selected == index2 + 1 ? 'bg-color' : ''"
            @click="open(items.monthitems, items.pr_detail, index2 + 1)"
          >
            <div class="list-cell__150" v-if="querytype == '客户'">
              {{ items.cu_name }}
            </div>
            <div class="list-cell__toggle" v-if="querytype == '客户'">
              {{ items.cu_code }}
            </div>
            <div class="list-cell__toggle">{{ items.pr_orispeccode }}</div>
            <div class="list-cell__toggle">{{ items.pr_spec }}</div>
            <div class="list-cell__toggle">{{ items.amount }}</div>
            <div class="list-cell__toggle">{{ items.pr_brand }}</div>
            <div class="list-cell__toggle">{{ items.pr_unit }}</div>
            <div class="list-cell__toggle">{{ items.ggkc }}</div>
            <div class="list-cell__toggle">{{ items.ggzt }}</div>
            <div class="list-cell__toggle">{{ items.pr_zxbzs }}</div>
            <div class="list-cell__toggle color-purple">
              {{ items.monthitems[8].saleQty }}
            </div>
            <div class="list-cell__toggle color-red">
              {{ items.monthitems[8].forecast }}
            </div>
            <div class="list-cell__toggle" v-if="querytype != '客户'">
              {{ items.monthitems[8].netDemand }}
            </div>
            <div
              class="list-cell__toggle color-blue"
              v-if="querytype != '客户'"
            >
              {{ items.monthitems[8].need }}
            </div>
            <div class="list-cell__toggle color-purple">
              {{ items.monthitems[9].saleQty }}
            </div>
            <div class="list-cell__toggle color-red">
              {{ items.monthitems[9].forecast }}
            </div>
            <div class="list-cell__toggle" v-if="querytype != '客户'">
              {{ items.monthitems[9].netDemand }}
            </div>
            <div
              class="list-cell__toggle color-blue"
              v-if="querytype != '客户'"
            >
              {{ items.monthitems[9].need }}
            </div>
            <div class="list-cell__toggle color-purple">
              {{ items.monthitems[10].saleQty }}
            </div>
            <div class="list-cell__toggle color-red">
              {{ items.monthitems[10].forecast }}
            </div>
            <div class="list-cell__toggle" v-if="querytype != '客户'">
              {{ items.monthitems[10].netDemand }}
            </div>
            <div
              class="list-cell__toggle color-blue"
              v-if="querytype != '客户'"
            >
              {{ items.monthitems[10].need }}
            </div>
            <div class="list-cell__toggle color-purple">
              {{ items.monthitems[11].saleQty }}
            </div>
            <div class="list-cell__toggle color-red">
              {{ items.monthitems[11].forecast }}
            </div>
            <div class="list-cell__toggle" v-if="querytype != '客户'">
              {{ items.monthitems[11].netDemand }}
            </div>
            <div
              class="list-cell__toggle color-blue"
              v-if="querytype != '客户'"
            >
              {{ items.monthitems[11].need }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import F2 from '@antv/f2'
import F2 from "@antv/f2/lib/index";
import ScrollBar from "@antv/f2/lib/plugin/scroll-bar";
import "@antv/f2/lib/interaction/pan";

export default {
  data() {
    let year = new Date().getFullYear();

    return {
      result: {},
      querytype: "全部",
      querytypeObj: {
        全部: "prod",
        客户: "cust",
      },
      list: [],
      year,
      chart: null,
      textArr: [],
      title: "物料",
      selected: 1,
    };
  },
  mounted() {
    this.searchCashflowMonth();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    searchCashflowMonth() {
      let me = this;

      me.$ajax({
        url: "/api/storage/report/saleForecastMonth",
        params: {
          year: me.year,
          querytype: me.querytypeObj[me.querytype] || "prod",
        },
      }).then(function (res) {
        if (res.success) {
          me.result = res.data;
          if (me.result && me.result.details) {
            me.title = me.result?.details[0].pr_detail;
          }
          me.initChart(me.deal(me.result.monthitems));
          me.list = me.result.details;
        }
      });
    },
    open(data, name, index) {
      let me = this,
        list = [];
      list = data;
      me.title = name;
      me.selected = index;
      me.initChart(me.deal(list));
    },
    deal(data) {
      if (!data) return;
      let me = this;
      me.textArr = [];
      for (let i = 0; i < 12; i++) {
        me.textArr.push(data[i].text);
      }
      let arr = [
        { index: -1, type: "销售订单", value: 0 },
        { index: 12, type: "销售订单", value: 0 },
      ];
      for (let i = 0; i < 12; i++) {
        arr.push(
          {
            index: i,
            text: me.textArr[i],
            type: "销售订单",
            value: data[i]?.saleQty || 0,
          },
          {
            index: i,
            text: me.textArr[i],
            type: "销售出货",
            value: data[i]?.qty || 0,
          },
          {
            index: i,
            text: me.textArr[i],
            type: "销售预测",
            value: data[i]?.forecast || 0,
          },
          {
            index: i,
            text: me.textArr[i],
            type: "需求预测",
            value: data[i]?.need || 0,
          }
        );
      }
      return arr;
    },
    onResize() {
      var chart = this.chart;
      if (chart) {
        this.chart = chart.destroy();
        this.initChart(this.deal(this.result.monthitems));
      }
    },
    initChart(data) {
      var me = this,
        chart = me.chart;
      if (chart) {
        chart.changeData(data);
        return;
      }
      me.chart = chart = new F2.Chart({
        id: "myChart",
        width: window.innerWidth,
        height: Math.min(window.innerHeight * 0.6, 300),
        pixelRatio: window.devicePixelRatio,
        plugins: ScrollBar,
      });
      chart.source(data, {
        index: {
          type: "linear",
          tickInterval: 1,
          min: -1,
          max: window.innerWidth > window.innerHeight ? 12 : 6,
          formatter: function (i) {
            return me.textArr[i];
          },
        },
      });

      chart
        .interval()
        .position("index*value")
        .color("type", (val) => {
          if (val === "销售订单") {
            return "#3E72F0";
          } else if (val === "销售出货") {
            return "#16b603";
          } else if (val === "销售预测") {
            return "#e44959";
          } else if (val === "需求预测") {
            return "#2eadf5";
          }
        })
        .adjust({
          type: "dodge",
          marginRatio: 0.01, // 设置分组间柱子的间距
        });

      if (window.innerWidth < window.innerHeight) {
        // 定义进度条
        chart.scrollBar({
          mode: "x",
          xStyle: {
            backgroundColor: "#e8e8e8",
            fillerColor: "#808080",
            offsetY: -2,
          },
        });
      }
      chart.legend({
        align: "center",
        itemWidth: null,
      });
      chart.interaction("pan");
      chart.render();
    },
  },
};
</script>

<style scoped>
.bg-color {
  background: #fabcc1;
}
.color-purple {
  color: #3e72f0;
}
.color-red {
  color: #e44959;
}
.color-blue {
  color: #2eadf5;
}
.filter-bar {
  width: 100%;
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
  display: flex;
}
.filter-bar span {
  margin: 0 auto;
  flex: 1;
  position: relative;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.filter-item__select option {
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}
.nav {
  padding: 10px 20px;
  display: flex;
  justify-content: space-around;
  background: var(--weui-BG);
}
.nav .selected {
  color: #38559f;
}
.canvas-title {
  padding-top: 10px;
  font-size: 12px;
  font-weight: bold;
  width: 100%;
  text-align: center;
  background: var(--weui-BG);
}
.canvas-box {
  /* width: 100%;
  height: 100%; */
  background: var(--weui-BG);
}

.list-box {
  margin-top: 5px;
  background: var(--weui-BG);
  display: flex;
}
.list-left {
  width: 180px;
  display: flex;
  flex-direction: column;
}
.list-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-x: scroll;
}
.report-item {
  width: calc(100% - 20px);
  height: 30px;
  margin: 0 auto;
  font-size: 13px;
  border-bottom: 1px solid #cccccc;
  line-height: 30px;
  color: var(--weui-FG-0);
  display: flex;
}
.font-bold {
  font-weight: bold;
}
.report-item .report-item-name {
  flex: 2;
  text-align: left;
  padding: 0 2px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.report-item .report-item-year {
  flex: 1;
  text-align: center;
  padding: 0 2px;
}
.report-item .report-item-month {
  flex: 1;
  text-align: center;
  padding: 0 2px;
}

.list-cell {
  background-color: #fff;
  border-top: 1px solid #cccccc;
  border-right: 1px solid #cccccc;
}
.list-left > .list-cell {
  border-left: 1px solid #cccccc;
}
.width-all {
  width: 2420px;
}
.width-customer {
  width: 1800px;
}
.list-cell__main {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
}
.height-36 {
  height: 36px !important;
}
.list-cell__index {
  width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list-cell__index span {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  background-color: #c0c0c0;
}
.list-cell__content {
  width: 144px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: #000;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-cell__150 {
  width: 150px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: #000;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-cell__toggle {
  width: 100px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.text-header {
  font-weight: bold;
  color: #000 !important;
}

.text-two-header {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  text-align: center;
}
.width-400 {
  width: 400px;
}
.width-200 {
  width: 200px;
}
.text-two-header > div {
  height: 18px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  border-left: 1px dashed #8b8b8b;
}

.small-header {
  display: inline-block;
  width: 84px;
  height: 18px;
  text-align: center;
  font-size: 12px !important;
  font-weight: bold;
}
.gray {
  /* max-height: 300px;
  overflow-y: auto; */
  background: #f4f4f4;
}
@media screen and (min-width: 500px) {
  .filter-bar {
    padding: 6px 0 2px 0;
  }
  .list-cell__toggle {
    height: 20px;
    line-height: 20px;
  }
  .list-cell__content {
    height: 20px;
    line-height: 20px;
  }
  .list-cell__index span {
    width: 20px;
    height: 20px;
  }
  .list-cell__main {
    padding: 5px 0px;
  }
}
</style>